export default __webpack_public_path__ + "static/media/gallery.e29f9880.png";